import { useDispatch } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { Facebook, Instagram, Twitter, Youtube } from 'lucide-react';
import logo from '../../assets/images/logo/logo.png';
import * as CommonActions from '../../redux/actions/commonAction';
import { useCommonContext } from '../../contexts/CommonContext';

const Footer = () => {
    const dispatch = useDispatch();
    const { sidebarWidth } = useCommonContext();
    const location = useLocation();
    const isDashboardRoute = location.pathname.startsWith("/dashboard") || location.pathname.startsWith("/verification") || location.pathname.startsWith("/profile/edit");

    return (
        <footer className={`bg-[#1a222c] text-gray-300 py-10 px-10 max-md:px-4`} style={{ marginLeft: isDashboardRoute ? sidebarWidth : '' }}>
            <div className="flex flex-col md:flex-row flex-wrap justify-between gap-10">
                {/* Logo & Description */}
                <div className="flex-1 min-w-[250px]">
                    <img src={logo} alt="Bharat Darshan Logo" className="w-60 mb-4" />
                    <p className="text-sm leading-relaxed">
                        Your one-stop solution for travel, accommodation, and finding your perfect match
                    </p>
                    <div className="flex items-center space-x-4 mt-4">
                        <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" className="hover:text-white"><Facebook size={18} /></a>
                        <a href="https://x.com" target="_blank" rel="noopener noreferrer" className="hover:text-white"><Twitter size={18} /></a>
                        <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer" className="hover:text-white"><Instagram size={18} /></a>
                        <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="hover:text-white"><Youtube size={24} /></a>
                    </div>
                </div>

                <div className="flex-1 min-w-[200px]">
                    <h4 className="text-white font-semibold text-lg mb-4">Quick Links</h4>
                    <ul className="space-y-2 text-sm">
                        <li><Link to="/about-us" className="hover:text-white">About Us</Link></li>
                        <li><Link to="/contact-us" className="hover:text-white">Contact Us</Link></li>
                        <li><Link to="/milan-sathi" className="hover:text-white">Milan Sathi</Link></li>
                    </ul>
                </div>

                <div className="flex-1 min-w-[200px]">
                    <h4 className="text-white font-semibold text-lg mb-4">Services</h4>
                    <div className="flex flex-col items-start space-y-3 text-sm">
                        {/* <button onClick={() => dispatch(CommonActions?.openDownloadOurAppModal(true))}>Flight Booking</button>
                        <button onClick={() => dispatch(CommonActions?.openDownloadOurAppModal(true))}>Hotel Booking</button> */}
                        <Link to="/tbo/flight-search" className="hover:text-white">Flight Booking</Link>
                        <Link to="/tbo/hotel-search" className="hover:text-white">Hotel Booking</Link>
                        <Link to="/milan-sathi" className="hover:text-white">Milan Sathi</Link>
                    </div>
                </div>

                <div className="flex-1 min-w-[250px]">
                    <h4 className="text-white font-semibold text-lg mb-4">Contact Us</h4>
                    <div className='flex flex-col gap-5'>
                        <div className="flex flex-col space-y-3 text-sm">
                            <p>Unit no -1104/1106/1108  11th floor tower - A spectrum metro mall Sec -75 Noida -GB Nagar Uttar Pradesh 201301</p>
                            <a role="button" aria-label="Contact Us on WhatsApp" href="https://wa.me/917070878744" target="_blank" rel="noopener noreferrer">+91 7070878744</a>
                            <a href="mailto:pr@bharatdarshan.today?subject=Support%20Request" target="_blank">pr@bharatdarshan.today</a>
                        </div>

                        <a role="button" aria-label="Contact Us on WhatsApp" href="https://wa.me/917070878744" target="_blank" rel="noopener noreferrer" className="bg-green-600 hover:bg-green-700 text-white px-5 py-2 rounded-md font-medium self-start">Contact Us on WhatsApp</a>
                    </div>
                </div>
            </div>

            <hr className="my-8 border-gray-700" />

            <div className="flex flex-col md:flex-row justify-between text-sm text-center md:text-left gap-4">
                <p>&copy; 2025 Bharat Darshan. All rights reserved.</p>
                <div className="space-x-4">
                    <Link to="/terms-of-use" className="hover:text-white">Terms & Conditions</Link>
                    <Link to="/privacy-policy" className="hover:text-white">Privacy Policy</Link>
                    <Link to="/refund-policy" className="hover:text-white">Refund Policy</Link>
                </div>
            </div>
        </footer>
    );
}

export default Footer;